/**
 * Sezione Preferenze - Tema, Lingua, Colore
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Sun, Moon } from 'lucide-react';
import ThemeColorSelector from '../ThemeColorSelector';

interface PreferencesSectionProps {
  t: (key: string) => string;
  theme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark') => void;
  locale: string;
  changeLocale: (locale: string) => void;
  primaryColor?: string;
  setPrimaryColor?: (color: string) => Promise<void>;
  PRIMARY_COLORS?: readonly { name: string; value: string; hsl: string }[];
}

const PreferencesSection: React.FC<PreferencesSectionProps> = ({ 
  t, 
  theme, 
  setTheme, 
  locale, 
  changeLocale,
  primaryColor,
  setPrimaryColor,
  PRIMARY_COLORS
}) => {
  return (
    <Card data-testid="preferences-section">
      <CardHeader>
        <CardTitle className="font-heading">{t('settings.preferences')}</CardTitle>
        <CardDescription>
          {t('settings.preferencesDescription')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Tema */}
        <div className="space-y-2">
          <Label>{t('settings.theme')}</Label>
          <div className="flex gap-2">
            <Button
              variant={theme === 'light' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setTheme('light')}
              data-testid="theme-light-btn"
            >
              <Sun className="h-4 w-4 mr-2" />
              {t('settings.lightTheme')}
            </Button>
            <Button
              variant={theme === 'dark' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setTheme('dark')}
              data-testid="theme-dark-btn"
            >
              <Moon className="h-4 w-4 mr-2" />
              {t('settings.darkTheme')}
            </Button>
          </div>
        </div>

        {/* Lingua */}
        <div className="space-y-2">
          <Label>{t('settings.language')}</Label>
          <div className="flex gap-2">
            <Button
              variant={locale === 'it' ? 'default' : 'outline'}
              size="sm"
              onClick={() => changeLocale('it')}
              data-testid="locale-it-btn"
            >
              🇮🇹 Italiano
            </Button>
            <Button
              variant={locale === 'en' ? 'default' : 'outline'}
              size="sm"
              onClick={() => changeLocale('en')}
              data-testid="locale-en-btn"
            >
              🇬🇧 English
            </Button>
          </div>
        </div>

        {/* Colore Tema con selettore avanzato */}
        <ThemeColorSelector />
      </CardContent>
    </Card>
  );
};

export default PreferencesSection;
